/*
* Copyright (C) Regione Lombardia
*/
import { AfterViewChecked, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { CoreAppConfigs } from '@core/configs/app.configs';
import { DatalistAnagrafica } from '@models';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { UtenteService } from '@shared/services/utente.service';
import { forkJoin, map } from 'rxjs';

@Component({
    selector: 'app-layout-header',
    templateUrl: './header.component.html',
})
export class LayoutHeaderComponent implements OnInit, AfterViewChecked {

    public appNameDesktop = CoreAppConfigs.NAME_DESKTOP;
    public appNameMobile = CoreAppConfigs.NAME_MOBILE;
    public showMobileMenu = false;
    public datalist: DatalistAnagrafica = {
        ente: [],
        ruolo: [],
    };
    @ViewChild('anchorDropDown') anchorDropDown: ElementRef;

    constructor(
        public utenteService: UtenteService,
        private anagraficaService: AnagraficaService,
        private router: Router,
        private renderer: Renderer2
    ) {
        this.router.events.subscribe(event => {
            if (
                event instanceof NavigationEnd ||
                event instanceof NavigationError ||
                event instanceof NavigationCancel
            ) {
                this.showMobileMenu = false;
            }
        });
    }

    ngOnInit() {
        if(this.utenteService.utente && this.utenteService.utente.codiceFiscale) {
            forkJoin([
                this.anagraficaService.getEnte(),
                this.anagraficaService.getRuolo(),
            ]).pipe(
                map(([
                    responseAnagraficaEnte,
                    responseAnagraficaRuolo,
                ]) => {
                    this.datalist = {
                        ente: responseAnagraficaEnte,
                        ruolo: responseAnagraficaRuolo,
                    }
                })
            ).subscribe();
        }
    }

    public logout() {
        this.utenteService.logout().subscribe((logoutUrl: any) => {
            window.open(logoutUrl.urlRedirectLogout, '_self');
        });
    }

    public login() {
        window.location.href = 'api/private/auth';
    }

    //Accessibility
    
    ngAfterViewChecked(): void {
        if (this.anchorDropDown !== undefined ) {
            this.renderer.removeAttribute(this.anchorDropDown.nativeElement, 'aria-expanded');
        }
    }
}
